import { ReCaptchaProvider } from 'next-recaptcha-v3';

import { Footer } from '@/components/Landing/LandingFooter';
import { LandingHelp } from '@/components/Landing/LandingHelp';

import { ENV } from '@/environment/client';

import { MarketingPageHeader } from '../Header/MarketingPageHeader';
import { ComparisonSection } from './ComparisonSection';
import { CrossChainHero } from './CrossChainHero';
import { CrossChainLiquiditySection } from './CrossChainLiquiditySection';
import { SignupForm } from './SignupForm';
import { SupportedChainsSection } from './SupportedChainsSection';
import { TokenOpportunitiesSection } from './TokenOpportunitiesSection';
import { TransactionProcessingSection } from './TransactionProcessingSection';
import { UsersProfilesSection } from './UserProfilesSection';

export function CrossChainSwaps() {
  return (
    <ReCaptchaProvider reCaptchaKey={ENV.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY}>
      <MarketingPageHeader />
      <CrossChainHero />
      <main className="mx-4.5 tablet:mx-17 desktop:mx-auto desktop:p-4 pb-0" data-lock-theme="true">
        <TransactionProcessingSection />
        <TokenOpportunitiesSection />
        <ComparisonSection />
        <CrossChainLiquiditySection />
        <SupportedChainsSection />
        <UsersProfilesSection />
        <SignupForm />
        <LandingHelp />
      </main>
      <Footer />
    </ReCaptchaProvider>
  );
}
